<template>
  <!-- 用户中心信息 -->
  <div class="page_padding">
    <div class="page_content" v-if="authority">
      <div class="head topAn">
        <!-- 筛选 -->
        <div class="form_box">
          <el-form
            class="form"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="80px"
          >
            <!-- 用户名 -->
            <el-form-item class="form_item" label="用户名" prop="username">
              <el-input
                type="text"
                style="position:fixed;bottom: -99999px;"
              ></el-input>
              <el-input
                type="text"
                v-model="ruleForm.username"
                placeholder="请输入用户名"
                clearable
                @change="submitForm"
              ></el-input>
            </el-form-item>
            <!-- 用户密码 -->
            <el-form-item class="form_item" label="用户密码" prop="password">
              <el-input
                type="password"
                style="position:fixed;bottom: -99999px;"
              ></el-input>
              <el-input
                type="password"
                v-model="ruleForm.password"
                placeholder="请输入用户密码"
                clearable
                show-password
                @change="submitForm"
              ></el-input>
            </el-form-item>
            <!-- 是否方舟 -->
            <el-form-item
              class="form_item"
              style="margin-left: 5px;"
              label="是否方舟"
            >
              <el-switch
                class="switch"
                style="margin-right: 10px"
                v-model="ruleForm.isMatrix"
                active-color="#525F7F"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-form>
          <el-button
            class="btn"
            type="primary"
            :disabled="btn_loading"
            :loading="btn_loading"
            @click="submitForm"
            >搜索</el-button
          >
        </div>
      </div>

      <div v-if="user_info != ''">
        <el-button
          class="add_btn"
          type="text"
          @click="addUser"
          :loading="loading"
          :disabled="loading"
          >添加用户</el-button
        >
      </div>

      <!-- 用户中心信息 -->
      <div class="user_info" v-load="btn_loading">
        <pre>{{ user_info }}</pre>
      </div>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user_info: "",
      // 表单
      ruleForm: {
        username: "",
        password: "",
        isMatrix: "0"
      },
      // 表单检验规则
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入用户密码", trigger: "blur" }
        ]
      },
      btn_loading: false,
      loading: false,
      userForm: {
        userid: "",
        username: "",
        companyid: "",
        companyName: "",
        losestatus: "0", // 0.永久用户，1.短期用户
        losetime: "", // 失效时间
        loginname: "",
        password: "",
        createname: "",
        desc: "",
        isMatrix: "",
        userPhone: ""
      },
      companyName: ""
    };
  },
  computed: {
    authority() {
      return this.$route.meta.authority;
    }
  },
  mounted() {},
  methods: {
    // 获取账号信息
    getInfo() {
      this.btn_loading = true;
      this.$http({
        url: this.$api.user_info,
        data: this.ruleForm
      }).then(res => {
        this.btn_loading = false;
        if (res.code == 0) {
          this.user_info = res.data;
          this.userForm.loginname = this.ruleForm.username;
          this.userForm.password = this.ruleForm.password;
          this.userForm.isMatrix = this.ruleForm.isMatrix;
          this.userForm.userid = res.data.userId;
          this.userForm.username = res.data.userName;
          this.userForm.companyid = res.data.customerId;
          this.userForm.companyName = res.data.customerName;
          this.userForm.userPhone = res.data.userPhone;
          this.companyName = res.data.customerName;
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 搜索
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.getInfo();
        } else {
          return false;
        }
      });
    },
    // 添加用户/公司
    addUser() {
      this.loading = true;
      // 添加用户
      this.$http({
        url: this.$api.add_user,
        data: this.userForm
      }).then(res => {
        this.loading = false;
        this.btnLoading = false;
        if (res.code == 0) {
          this.$hint("添加成功");
        } else {
          this.$hint(res.code + res.message, "err");
        }
      });
      // 添加公司
      this.$http({
        url: this.$api.add_company,
        data: {
          companyname: this.companyName,
          companyid: this.userForm.companyid
        }
      }).then(res => {});
    }
  }
};
</script>

<style></style>
<style lang="less" scoped>
.form_box {
  display: flex;
  align-items: center;
  transform: scale(0.85);
}
.form {
  height: 40px;
  display: flex;
  .form_item {
    height: 35px;
    margin: 0;
    margin-right: 10px;
  }
}
.btn {
  height: 38px;
  padding: 0 20px;
}
.user_info {
  height: 0;
  flex: 1;
  // margin-top: 15px;
  border-top: 1px solid #eee;
  padding: 20px 0;
  overflow-y: scroll;
}
.add_btn {
  font-size: 13px;
  color: #525f7f;
  font-weight: bold;
}
.user_info::-webkit-scrollbar {
  width: 0 !important;
}
.user_info::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

.el-input {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/userInfo.vue